import { Component } from '@angular/core';
import { FormComponentLookup } from '@ptl/forms';
import { MassUploadFormControlComponent } from '../mass-upload-form-control.component';
import { debounceTime, distinctUntilChanged, filter, switchMap, tap } from 'rxjs/operators';
import moment from 'moment';
import { MOMENT_PARSE_FORMAT, SUBMISSION_DATE_FORMAT } from '../../../../producer/mass-upload-grid/interfaces/mug-submission.interface';
import { DropdownOption, EMPTY_DROPDOWN_OPTION, EXCEL_ENROLLMENT_TYPES } from '../../../../producer/mass-upload-grid/interfaces/mass-upload-grid.interface';

@FormComponentLookup('mass-upload-grid-control-effective-date')
@Component({
  selector: 'app-mass-upload-effective-date-form-control',
  templateUrl: '../mass-upload-form-control.component.html',
  styleUrl: '../mass-upload-form-control.component.scss',
  standalone: false
})
export class MassUploadEffectiveDateFormControlComponent extends MassUploadFormControlComponent {

  ngOnInit() {
    super.ngOnInit();
    
    this.mugService.transformExcelDateToMoment(this.entry, this.selfAsFormControl);
    
    // first, standardize MM/DD/YYYY format on the incoming value to account for M, MM, D, DD combinations
    // NOTE: setDefaultValue is never a true date, but a string in the format MM/DD/YYYY
    if (this.entry.formControlAttributes.setDefaultValue) {
      this.entry.formControlAttributes.setDefaultValue = 
      moment(this.entry.formControlAttributes.setDefaultValue, MOMENT_PARSE_FORMAT)
        .format(SUBMISSION_DATE_FORMAT);
      this.resetFormValue(this.entry.formControlAttributes.setDefaultValue);
    }

    // Effective date specific initialization
    this.isDropdown = true;
    this.dropdownOptions = [];

    let countyControl = this.getCountyControl();
    this.subscriptionGroup.push(countyControl.valueChanges.pipe(
        distinctUntilChanged(),
        tap(() => {
          this.isLoading = true;
        }),
        switchMap(async (countyName) => {
          let county = await this.getCounty();
          
          if (!county) {
            return [];
          }
          
          return this.mugService.loadEffectiveDatesForRegion(county?.region, this.mugDataHelperService.getEnrollmentTypeByStateId(this.stateId));
        })
      )
      .subscribe((effectiveDates: DropdownOption[]) => {
        this.isLoading = false;
        
        // Optional custom json attribute to filter out effective dates based on the year
        if (this.entry.custom?.filterEffectiveDatesByYears) {
          let thisYear = this.dateService.getTodayAsMoment().year();
          let defaultYears = [thisYear.toString(), (thisYear + 1).toString()];
          let enrollmentType = this.mugDataHelperService.getEnrollmentTypeByStateId(this.stateId);
          let validYears = this.entry.custom.filterEffectiveDatesByYears[enrollmentType] || defaultYears;

          effectiveDates = effectiveDates.filter((option) => {
            for (let i = 0; i < validYears.length; i++) {
              if (option.value.toString().indexOf(validYears[i]) != -1) {
                return true;
              }
            }
          });
        }

        this.dropdownOptions = EMPTY_DROPDOWN_OPTION.concat(effectiveDates);

        if (!this.dropdownOptions.filter((ddOpt) => ddOpt.value === this.selfAsFormControl.value).length) {
          this.resetFormValue(null);
        }
      }));
  }
}
